module.exports = __webpack_public_path__ + "img/8.ee9cbf60.jpg";